import useGraph from './useGraph';

const useJobOutputs = () => {
  const { outputBlobs: outputs } = useGraph();

  return outputs;
};

export default useJobOutputs;
